export default "__VITE_ASSET__EWr$erbo__"